export default "__VITE_ASSET__DSjgBs44__"